import React, { useContext, useEffect, useState, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import Image from '../common/image';
import x from '../../assest/images/x.png';
import Icon4 from "../../assest/images/Icon4.png";
import Icon3 from "../../assest/images/Icon3.png";
import Icon9 from '../../assest/images/Icon9.png';
import ConfirmationPopup from '../common/ConfirmationPopup ';
import { ToastContainer, toast } from 'react-toastify';
import config from "../../envconfig";
import CustomDropdown from '../common/CustomDropdown';
import axios from 'axios';
import { UserContext } from '../common/UserContext';


function SCPMasterList() {

    // const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useParams(); // Updated to include selectedScpId
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);

    useEffect(() => {
        sessionStorage.setItem('UM_GroupId', UM_GroupId);
        sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
        sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
        sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
        sessionStorage.setItem('UM_UserId', UM_UserId);
        sessionStorage.setItem('UM_UserCode', UM_UserCode);

        sessionStorage.setItem('selectedScpId', selectedScpId);

    }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);

    const [userData, setUserData] = useState([]);
    const [message, setMessage] = useState('');

    const [scpPopup, setScpPopup] = useState(false);
    const [scpNames, setSCPNames] = useState([]);

    const [scpOPPopup, setScpOPPopup] = useState(false);
    const [scpOPNames, setSCPOPNames] = useState([]);

    const [firstFilter, setFirstFilter] = useState('');
    const [firstFilterSearch, setFirstFilterSearch] = useState('');
    const [secondFilter, setSecondFilter] = useState('');
    const [secondFilterSearch, setSecondFilterSearch] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [statusFilter, setStatusFilter] = useState('');

    // State variable to control the visibility of the confirmation popup
    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
    const [suspendId, setSuspendId] = useState(null);

    const [firstFilterOptions, setFirstFilterOptions] = useState([
        { value: 'SCPM_Name', label: 'SCP Name', disabled: false },
        { value: 'SCPM_Caption', label: 'SCP Caption Name', disabled: false },
        { value: 'SCPM_Code', label: 'SCP Code', disabled: false },
        { value: 'SCP_LevelName', label: 'SCP Level Name', disabled: false },
    ]);
    const [secondFilterOptions, setSecondFilterOptions] = useState([
        { value: 'SCPM_Name', label: 'SCP Name', disabled: false },
        { value: 'SCPM_Caption', label: 'SCP Caption Name', disabled: false },
        { value: 'SCPM_Code', label: 'SCP Code', disabled: false },
        { value: 'SCP_LevelName', label: 'SCP Level Name', disabled: false },
    ]);

      const toastRef = useRef(null);
    const showToast = (type, message, options = {}) => {
      if (toastRef.current && toast.isActive(toastRef.current)) {
        toast.update(toastRef.current, {
          render: message,
          type,
          autoClose: 3000,
          ...options,
        });
      } else {
        toastRef.current = toast[type](message, {
          autoClose: 3000,
          ...options,
        });
      }
    };
    const audittransection = async (data) => {
        const formData = {
            AUTRN_ID: data.AUTRN_ID,
            AUTRN_OldValue: data.AUTRN_OldValue ?? null,
            AUTRN_NewValue: data.AUTRN_NewValue,
            AUTRN_ParamererName: data.AUTRN_ParamererName
        };
        try {
            const response = await axios.post(`${config.API_URL}/api/audittransaction`, formData);
            // alert('Data inserted successfully');
        } catch (error) {
            if (error.response) {
                console.error('Server responded with an error:', error.response.data);
            } else if (error.request) {
                console.error('No response received:', error.request);
            } else {
                console.error('Error setting up the request:', error.message);

            }
        }
    }
    const audittrailpost = async (details) => {
        const getCurrentTimestamp = () => {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0'); // months are zero-indexed
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };
        const currentTimestamp = getCurrentTimestamp();
        const AUTR_OldValue = details?.AUTR_OldValue ?? null;
        const AUTR_NewValue = details?.AUTR_NewValue ?? null;
        const AUTR_Message = details.AUTR_Message;
        const AUTR_AuditType = details.AUTR_AuditType;
        if (UM_CompanyID === null || UM_CompanyID === "null" || UM_CompanyGrpID === null || UM_CompanyGrpID === "null" || selectedScpId === null || selectedScpId === "null") {
            console.log("null--------")
            const data = {
                AUTR_ScreenName: "User Master",
                AUTR_OldValue: AUTR_OldValue,
                AUTR_NewValue: AUTR_NewValue,
                AUTR_Message: AUTR_Message,
                AUTR_UserID: UM_UserId,
                AUTR_UserName: UM_UserCode,
                AUTR_TimeStamp: currentTimestamp,
                AUTR_AuditType: AUTR_AuditType,
                AUTR_SCPID: null,
                AUTR_CompanyGrpId: null,
                AUTR_CompanyID: null,
                AUTR_CreatedBy: UM_UserId,
                AUTR_CreatedDateTime: currentTimestamp
            };
            console.log(data)
            try {
                const response = await axios.post(`${config.API_URL}/api/audittrail`, data);
                console.log('Success:', response.data);
                return response.data;
            } catch (error) {
                console.error('Error:', error);
            }
        } else {
            console.log("null--------")
            const data = {
                AUTR_ScreenName: "SCP Master",
                AUTR_OldValue: AUTR_OldValue,
                AUTR_NewValue: AUTR_NewValue,
                AUTR_Message: AUTR_Message,
                AUTR_UserID: UM_UserId,
                AUTR_UserName: UM_UserCode,
                AUTR_TimeStamp: currentTimestamp,
                AUTR_AuditType: AUTR_AuditType,
                AUTR_SCPID: selectedScpId,
                AUTR_CompanyGrpId: UM_CompanyID,
                AUTR_CompanyID: UM_CompanyID,
                AUTR_CreatedBy: UM_UserId,
                AUTR_CreatedDateTime: currentTimestamp
            };
            console.log(data)
            try {
                const response = await axios.post(`${config.API_URL}/api/audittrail`, data);
                console.log('Success:', response.data);
                return response.data;
            } catch (error) {
                console.error('Error:', error);
            }
        }
    };
    useEffect(() => {
        // Whenever any of the filters change, reset to the first page
        setCurrentPage(1);
    }, [firstFilterSearch, secondFilterSearch, statusFilter]);
    const logAction = async (action, isError = false) => {
        console.log(`${isError ? '[ERROR] ' : ''}${action}`);
        try {
            const response = await fetch(`${config.API_URL}/api/log`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ module: "SCP-Configuration:", action, userCode: UM_UserCode, isError }),
            });

            if (!response.ok) {
                throw new Error('Failed to log action');
            }
        } catch (error) {
            console.error('Error logging action:', error);
        }
    };
    const handleSuspendWithConfirmation = (SCPM_ID) => {
        setSuspendId(SCPM_ID);
        setShowConfirmationPopup(true);
    };
    // const confirmSuspend = async (remark) => {
    //     console.log(suspendId);
    //     try {
    //         const response = await fetch(`${config.API_URL}/scp_master/Suspend/${suspendId.SCPM_ID}`, {
    //             method: 'PUT',
    //             headers: { 'content-type': 'application/json' },
    //             body: JSON.stringify({
    //                 SCPM_Status: 3,
    //                 SCP_SuspendRemark: remark, // Include the remark
    //             }),
    //         });
    //         if (response.ok) {
    //             // Update userData state after suspension
    //             const updatedUserData = userData.map(item => {
    //                 if (item.SCPM_ID === suspendId.SCPM_ID) {
    //                     return { ...item, SCPM_Status: 3 }; // Update status to Suspend
    //                 }
    //                 return item;
    //             });
    //             setUserData(updatedUserData);
    //             // Find the Suspend item and get its name
    //             const SuspendItem = updatedUserData.find(item => item.SCPM_ID === suspendId.SCPM_ID);

    //             if (SuspendItem) {
    //                 const details = {
    //                     AUTR_Message: `${suspendId.SCPM_Name} Suspend`,
    //                     AUTR_AuditType: "Suspend",
    //                     AUTR_OldValue: (suspendId.SCPM_Status === 1) ? "Active" :
    //                         (suspendId.SCPM_Status === 2) ? "Inactive" : "Unknown",
    //                     AUTR_NewValue: "Suspend"
    //                 };
    //                 let id = await (audittrailpost(details));
    //                 const details2 = {
    //                     AUTRN_ParamererName: "Status",
    //                     AUTRN_ID: id,
    //                     AUTRN_NewValue: "Suspend",
    //                     AUTRN_OldValue: (suspendId.SCPM_Status === 1) ? "Active" :
    //                         (suspendId.SCPM_Status === 2) ? "Inactive" : "Unknown"
    //                 };
    //                 audittransection(details2);
    //                 // logAction("handleSuspend(): SCP Master suspended successfully");
    //                 logAction(`handleSuspend(): SCP : ${suspendId.SCPM_Name} suspended successfully.`);
    //                 showToast('success',`SCP : ${suspendId.SCPM_Name} suspended successfully.`);
    //             } else {
    //                 console.error('Suspend item not found in updated user data.');
    //             }
    //         } else if (response.status === 400) {
    //             // Display error message if SCPM cannot be Suspend due to reference in usermaster table
    //             showToast('error',`You cannot suspend the SCP : ${suspendId.SCPM_Name} because a reference exists in User Master`);
    //         } else {
    //             const errorData = await response.json();
    //             // showToast('error',"SCP Master could not be suspended successfully");
    //             showToast('success',`SCP : ${suspendId.SCPM_Name} could not be suspended successfully.`);
    //             console.error('Error suspending SCP Master:', errorData.error);
    //             logAction("handleSuspend(): Error in SCP Master Suspend", true);
    //         }
    //     } catch (err) {
    //         console.error('Network error:', err);
    //         showToast('error',`SCP : ${suspendId.SCPM_Name} could not be suspended successfully.`);
    //         logAction("handleSuspend(): Error in SCP Master Suspend", true);
    //     }
    //     setShowConfirmationPopup(false);
    // };
    const confirmSuspend = async (remark) => {
  try {
    const response = await fetch(
      `${config.API_URL}/scp_master/Suspend/${suspendId.SCPM_ID}`,
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          SCP_SuspendRemark: remark
        }),
      }
    );

    // Read backend message (plain text)
    const message = await response.text();

    if (response.ok) {
      // Update state
      const updatedUserData = userData.map(item =>
        item.SCPM_ID === suspendId.SCPM_ID
          ? { ...item, SCPM_Status: 3 }
          : item
      );
      setUserData(updatedUserData);

      // Audit Trail
      const details = {
        AUTR_Message: `${suspendId.SCPM_Name} Suspend`,
        AUTR_AuditType: "Suspend",
        AUTR_OldValue:
          suspendId.SCPM_Status === 1 ? "Active" :
          suspendId.SCPM_Status === 2 ? "Inactive" : "Unknown",
        AUTR_NewValue: "Suspend"
      };

      const id = await audittrailpost(details);

      const details2 = {
        AUTRN_ParamererName: "Status",
        AUTRN_ID: id,
        AUTRN_NewValue: "Suspend",
        AUTRN_OldValue: details.AUTR_OldValue
      };

      audittransection(details2);

      logAction(`handleSuspend(): SCP : ${suspendId.SCPM_Name} suspended successfully.`);
      showToast('success',`SCP : ${suspendId.SCPM_Name} suspended successfully.`);

    } else if (response.status === 400) {
      // 🔥 Show exact backend validation message
      showToast('error',message);
    } else if (response.status === 404) {
      showToast('error',message);
    } else {
      showToast('error',`SCP : ${suspendId.SCPM_Name} could not be suspended.`);
      logAction("handleSuspend(): Error in SCP Master Suspend", true);
    }

  } catch (err) {
    console.error('Network error:', err);
    showToast('error',`SCP : ${suspendId.SCPM_Name} could not be suspended.`);
    logAction("handleSuspend(): Network error in SCP Master Suspend", true);
  }

  setShowConfirmationPopup(false);
};

    
    useEffect(() => {
        const getUserData = async () => {
            try {
                const reqData = await fetch(`${config.API_URL}/scp_master/${UM_CompanyID}`, {
                    method: 'GET',
                });
                if (reqData.ok) {
                    const resData = await reqData.json();
                    console.log('List of SCP Masters:', resData);
                    logAction("Open List of SCP Master")
                    setUserData(resData);
                } else {
                    console.error('Error fetching the SCP Master list');
                    logAction("Error fetching the SCP Master list", true)
                }
            } catch (error) {
                console.log('Failed to fetch data:', error);
                logAction("Failed to fetch data", true)
                setMessage('Please check Data');
            }
        };
        getUserData();
    }, [UM_CompanyID, message]);

    const fetchSCPNames = async (id) => {
        console.log("ID of SCP Same Level", id);
        try {
            const url = `${config.API_URL}/scpinward/popup/${id}`;
            const response = await fetch(url);

            if (response.ok) {
                const data = await response.json();
                if (data.success) {
                    // Assuming data.data is an array of SCP names
                    logAction("fetchSCPNames(): SCP Same Level data get from API")
                    setSCPNames(data.data);
                    console.log("data", data.data);
                    setMessage('');
                } else {
                    logAction("fetchSCPNames():Error in SCP Same Level data get from API", true)
                    setMessage('Error fetching SCP names');
                }
            } else {
                console.error('Error fetching SCP names. Status:', response.status);
                logAction("fetchSCPNames():Error in SCP Same Level data get from API", true)
            }
        } catch (error) {
            console.error('Failed to fetch SCP names:', error);
            logAction("fetchSCPNames():Error in SCP Same Level data get from API", true)
            setMessage('Please check the data');
        }
    };
    const fetchSCPOPNames = async (id) => {
        console.log("ID of SCP Outward Party", id);
        try {
            const url = `${config.API_URL}/scpoutward/popup/${id}`;
            const response = await fetch(url);

            if (response.ok) {
                const data = await response.json();
                if (data.success) {
                    // Assuming data.data is an array of SCP names
                    logAction("fetchSCPOPNames(): SCP Outward Party data get from API")
                    setSCPOPNames(data.data);
                    console.log("data", data.data);
                    setMessage('');
                } else {
                    setMessage('Error fetching SCP names');
                    logAction("fetchSCPOPNames():Error in SCP Outward data get from API", true)
                }
            } else {
                console.error('Error fetching SCP names. Status:', response.status);
                logAction("fetchSCPOPNames():Error in SCP Outward data get from API", true)
            }
        } catch (error) {
            console.error('Failed to fetch SCP names:', error);
            logAction("fetchSCPOPNames():Error in SCP Outward data get from API", true)
            setMessage('Please check the data');
        }
    };
    const handleScpPopup = (id) => {
        setScpPopup(true);
        fetchSCPNames(id);
        logAction("handleScpPopup(): SCP Same Level Popup open.")
    };
    const handleScpOPPopup = (id) => {
        setScpOPPopup(true);
        fetchSCPOPNames(id);
        logAction("handleScpOPPopup(): SCP Outward Party Popup open.")
    };
    const handleFirstFilterChange = (event) => {
        const value = event.target.value;
        setFirstFilter(value);
        setFirstFilterSearch('');
        const updatedSecondOptions = secondFilterOptions.map(option => ({
            ...option,
            disabled: option.value === value
        }));
        setSecondFilterOptions(updatedSecondOptions);
        logAction("handleFirstFilterChange(): First filter used")
    };
    const handleSecondFilterChange = (event) => {
        const value = event.target.value;
        setSecondFilter(value);
        setSecondFilterSearch('');

        const updatedFirstOptions = firstFilterOptions.map(option => ({
            ...option,
            disabled: option.value === value
        }));
        setFirstFilterOptions(updatedFirstOptions);
        logAction("handleSecondFilterChange(): Second filter used")
    };
    const handleStatusFilterChange = (event) => {
        const value = event.target.value;
        logAction("handleStatusFilterChange(): Status is changed in the dropdown");
        setStatusFilter(value);
        logAction("handleStatusFilterChange(): Data filtered according to the selected status");
    };
    const getStatusLabel = (status) => {
        switch (status) {
            case 1:
                return 'Active';
            case 2:
                return 'Inactive';
            case 3:
                return 'Suspend';
            default:
                return '';
        }
    };
    const filteredListData = userData.filter(item => {
        const firstFilterValue = item[firstFilter];
        const secondFilterValue = item[secondFilter];
        const statusValue =
            getStatusLabel(item.SCPM_Status);
        const containsActive = /act(ive)?/i.test(firstFilterSearch);
        const containsInactive = /inact(ive)?/i.test(firstFilterSearch);

        const matchesFirstFilter =
            (!firstFilter || !firstFilterSearch) ||
            (firstFilter === 'SCPM_Status' &&
                (
                    (containsActive && firstFilterValue === 1) ||
                    (containsInactive && firstFilterValue === 2)
                )
            ) ||
            (firstFilter !== 'SCPM_Status' && String(firstFilterValue).toLowerCase().includes(firstFilterSearch.toLowerCase()));
        const containsActive2 = /act(ive)?/i.test(secondFilterSearch);
        const containsInactive2 = /inact(ive)?/i.test(secondFilterSearch);

        const matchesSecondFilter =
            (!secondFilter || !secondFilterSearch) ||
            (secondFilter === 'SCPM_Status' &&
                (
                    (containsActive2 && secondFilterValue === 1) ||
                    (containsInactive2 && secondFilterValue === 2)
                )
            ) ||
            (secondFilter !== 'SCPM_Status' && String(secondFilterValue).toLowerCase().includes(secondFilterSearch.toLowerCase()));

        const matchesStatusFilter = !statusFilter || statusValue === statusFilter;

        return matchesFirstFilter && matchesSecondFilter && matchesStatusFilter;
    });
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredListData.slice(indexOfFirstItem, indexOfLastItem);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    return (
        <React.Fragment>
      
            <ToastContainer style={{
                marginTop: '73px',
                fontSize: '14px',
                width: '40%',
            }} />
            <div className="main_container">
                <h3 className="formHeading">
                    SCP Master
                </h3>
                <p>{message}</p>
                <div className="filter-container">
                    <div className='select-container_list'>
                        <CustomDropdown
                            options={firstFilterOptions}
                            value={firstFilter}
                            onChange={handleFirstFilterChange}
                            name="firstFilter"
                            placeholder="--Select--"
                            idKey="value"
                            displayKey="label"
                        />
                       
                    </div>
                    <input type="text"
                        className='search-input'
                        value={firstFilterSearch} onChange={(e) => setFirstFilterSearch(e.target.value)} placeholder={`Search`} />
                    <div className='select-container_list'>
                        <CustomDropdown
                            options={secondFilterOptions}
                            value={secondFilter}
                            onChange={handleSecondFilterChange}
                            name="secondFilter"
                            placeholder="--Select--"
                            idKey="value"
                            displayKey="label"
                        />
                     
                    </div>
                    <input type="text"
                        className='search-input'
                        value={secondFilterSearch} onChange={(e) => setSecondFilterSearch(e.target.value)} placeholder='Search' />
                    <div className='select-container_list'>
                        <CustomDropdown
                            options={[
                                // { value: '', label: '--Select Status--' },
                                { value: 'Active', label: 'Active' },
                                { value: 'Inactive', label: 'Inactive' },
                                { value: 'Suspend', label: 'Suspend' }
                            ]}
                            value={statusFilter}
                            onChange={handleStatusFilterChange}
                            name="statusFilter"
                            placeholder="--Select Status--"
                            idKey="value"
                            displayKey="label"
                        />
                      
                    </div>
                </div>
                <div>
                    {scpPopup && (
                        <>
                         <div className="popup_overlay">
                            <div className="popup">
                                <div>
                                    <Link onClick={() => setScpPopup(false)}>
                                        <Image src={x} alt="x" className="x" />
                                    </Link>
                                </div>
                                <h1>SCP Name List</h1>

                                <table className="tableClass">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>SCP Name</th>
                                        </tr>
                                    </thead>
                                    {scpNames.length === 0 ? (
                                        <tbody >
                                            <tr>
                                                <td colSpan="9">No Records Found</td> {/* Set colSpan to match the number of columns */}
                                            </tr>
                                        </tbody>

                                    ) : (
                                        <tbody>
                                            {scpNames.map((scpName, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{scpName.SCPM_Name}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    )}
                                </table>
                            </div>
                            </div>
                        </>
                    )}

                </div>
                <div>
                    {scpOPPopup && (
                        <>
                         <div className="popup_overlay">
                            <div className="popup">
                                <div>
                                    <Link onClick={() => setScpOPPopup(false)}><Image src={x} alt="x" className="x" /></Link>
                                </div>
                                <h1>SCP Name List</h1>
                                <table className="tableClass">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>SCP Name</th>
                                        </tr>
                                    </thead>
                                    {scpOPNames.length === 0 ? (
                                        <tbody >
                                            <tr>
                                                <td colSpan="9">No Records Found</td> {/* Set colSpan to match the number of columns */}
                                            </tr>
                                        </tbody>

                                    ) : (
                                        <tbody>
                                            {scpOPNames.map((scpOPName, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{scpOPName.SCPM_Name}</td>
                                                </tr>
                                            ))}

                                        </tbody>
                                    )}
                                </table>
                            </div>
                            </div>
                        </>
                    )}
                </div>
                <div className="ptable-wrapper">
                <table className="ptableClass">
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th>SCP Name</th>
                            <th>SCP Caption Name</th>
                            <th>SCP Code</th>
                            <th>SCP Level Name</th>
                            <th> SCP Outward Party </th>
                            <th>SCP Same Level Party</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    {filteredListData.length === 0 ? (
                        <tbody >
                            <tr>
                                <td colSpan="9">No Records Found</td> {/* Set colSpan to match the number of columns */}
                            </tr>
                        </tbody>
                    ) : (
                        <tbody>
                            {currentItems.map((user, index) => (
                                <tr key={index}>
                                    <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                                    <td>{user.SCPM_Name}</td>
                                    <td>{user.SCPM_Caption}</td>
                                    <td>{user.SCPM_Code}</td>
                                    <td>{user.SCP_LevelName}</td>
                                    <td>
                                        <Link
                                            onClick={() => handleScpPopup(user.SCPM_ID)}
                                            title='Details'
                                        >
                                            <Image src={Icon9} alt="pool" className="poolimage" />

                                            {user.UM_SCPCode}
                                        </Link>
                                    </td>
                                    <td>
                                        <Link
                                            onClick={() => handleScpOPPopup(user.SCPM_ID)}
                                            title='Details'
                                        >
                                            <Image src={Icon9} alt="pool" className="poolimage" />
                                            {user.UM_SCPCode}
                                        </Link>
                                    </td>
                                    <td>
                                        {user.SCPM_Status === 1 && 'Active'}
                                        {user.SCPM_Status === 2 && 'Inactive'}
                                        {user.SCPM_Status === 3 && 'Suspend'}
                                    </td>
                                    <td>
                                        {user.SCPM_Status !== 3 && (
                                            <Link to={`/dashboard/scpmedit/${user.SCPM_ID}`} className='' title='Edit'>
                                                <Image src={Icon3} alt="pencil" className="editicon" width={25} />
                                            </Link>
                                        )}

                                        {user.SCPM_Status !== 3 && (
                                            <img
                                                src={Icon4}
                                                title='Suspend'
                                                alt="suspendremovebg"
                                                className=""
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                    console.log("user:", user);
                                                    handleSuspendWithConfirmation(user)
                                                }}
                                            />
                                        ) || '-'}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    )}
                </table>
                </div>

                {/* Pagination */}
                <ul className="pagination">
                    {/* First Page Button */}
                    <li className={currentPage === 1 || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(1)}>First</button>
                    </li>

                    {/* Previous Page Button */}
                    <li className={currentPage === 1 || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(currentPage - 1)}>Previous</button>
                    </li>

                    {/* Page Numbers */}
                    {Array.from({ length: Math.ceil(filteredListData.length / itemsPerPage) }, (_, index) => (
                        <li key={index} className={currentPage === index + 1 ? "page-item active" : "page-item"}>
                            <button className="page-linkd" onClick={() => paginate(index + 1)}>{index + 1}</button>
                        </li>
                    ))}

                    {/* Next Page Button */}
                    <li className={currentPage === Math.ceil(filteredListData.length / itemsPerPage) || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(currentPage + 1)}>Next</button>
                    </li>

                    {/* Last Page Button */}
                    <li className={currentPage === Math.ceil(filteredListData.length / itemsPerPage) || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(Math.ceil(filteredListData.length / itemsPerPage))}>Last</button>
                    </li>
                </ul>

            </div>
            {showConfirmationPopup && (
                <ConfirmationPopup
                    message={`Are you sure you want to suspend this SCP : ${suspendId.SCPM_Name} ?`}
                    onCancel={() => setShowConfirmationPopup(false)}
                    onConfirm={confirmSuspend}
                />
            )}
            <Link to={`/dashboard/scpmaster`} className="back_btn" type="button">BACK</Link>
        </React.Fragment>
    );
}
export default SCPMasterList;

